<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Receipt Reprint",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Sale Receipt Reprint",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Receipt Reprint",
          active: true,
        },
      ],
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters("pharmacy", ["Sale"]),
  },
  methods: {
    ...mapActions({
      FetchSale: "pharmacy/fetchSale",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  updated() {
    setTimeout(() => {
      window.print();
    }, 1000);
  },
  created() {
    this.FetchSale(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> RePrint</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white p-2">
          <div class="print-font mt-4">
            <center>
              <b-spinner
                v-if="!Sale"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <img
                v-else
                :src="Sale ? Sale.clinic.clinicLogo : '--'"
                alt="Logo"
                height="70"
              />
              <br />
              <h4>
                <strong> {{ Sale ? Sale.clinic.clinicName : "---" }}</strong>
              </h4>
              <p>
                {{ Sale ? "+256" + Sale.clinic.clinicContact : "---" }}
                <br />
                {{ Sale ? Sale.clinic.clinicMail : "---" }}
              </p>
              <h5
                style="
                  text-decoration: underline;
                  text-transform: uppercase;
                  text-align: center;
                  font-weight: bold;
                  font-family: Courier New, Courier, Lucida Sans Typewriter,
                    Lucida Typewriter, monospace;
                "
              >
                PAYMENT RECEIPT REPRINT
              </h5>
            </center>
            <hr style="border-style: dashed; width: 97%" />
            <center>
              <table width="100%">
                <tr style="font-size: 17px">
                  <td><b>Sale Date</b></td>
                  <td>
                    {{ Sale ? Sale.saleDate : "--" }}
                  </td>
                </tr>
              </table>
            </center>
            <!-- <hr /> -->
            <div width="100%">
              <h5>Items Bought</h5>
              <center>
                <table width="100%" class="table" style="font-size: 17px">
                  <thead>
                    <tr>
                      <!-- <th>S/N</th> -->
                      <th width="50%">Item</th>
                      <th width="20%">QTY</th>
                      <th width="30%">Unit Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(record, r) in Sale.saledetails" :key="r">
                      <!-- <td>{{ r + 1 }}</td> -->
                      <td width="50%">{{ record.item.serviceName }}</td>
                      <td width="20%">{{ record.itemQty }}</td>
                      <td width="30%">{{ thousandSeprator(record.unitPrice) }}</td>
                    </tr>
                  </tbody>
                </table>
              </center>
            </div>
            <div style="width: 100%; font-size: 17px">
              <b>Total:</b>
              {{ this.thousandSeprator(Sale ? Sale.totalAmount : "0") }}/=
              <br />
              <b>Paid:</b>
              {{ this.thousandSeprator(Sale ? this.Sale.amountPaid : "0") }}/=
              <br />
              <b>Balance:</b>
              {{
                this.thousandSeprator(Sale ? Sale.totalAmount - Sale.amountPaid : "0")
              }}/=
            </div>
            <center>
              <hr style="border-style: dashed; width: 97%" />
              <p style="font-size: 17px">
                Signature ..........................................
                <br />Thank you for trusting
                <strong> {{ Sale ? Sale.clinic.clinicName : "---" }}</strong>
                <br />For more inquiries call
                <strong>+256{{ Sale ? Sale.clinic.clinicContact : "---" }}</strong>
              </p>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
